import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService
} from 'app/services';
import controller from './edit-vendor-manager-dialog.controller';
import template from './edit-vendor-manager-dialog.html';


class dialogService {
  getOptions($event, { vendorManager }) {
    return {
      controller,
      controllerAs: 'editVendorManagerDialogVM',
      locals: {
        vendorManager
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editVendorManagerDialog', [
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
])
  .service('editVendorManagerDialog', dialogService)
  .name;
